import script from "./BaseTag.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTag.vue?vue&type=script&setup=true&lang=js"

import "./BaseTag.vue?vue&type=style&index=0&id=1ad2d666&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad2d666"]])

export default __exports__